import Modal from '../modal'
import { Button } from '../button'

export default function OfferReceivedModal({ onClose }) {
  return (
    <Modal onClose={onClose}>
      <div className='wrapper flex flexDirectionColumn justifyBetween'>
        <div>
          <h2 className='title'>Your offer has been sent</h2>
          <p className='description'>
            Thank you for sending your offer. Once the seller receives an offer they can accept or
            send a counter offer. You can counter their offer up to 2 times.
          </p>

          <p className='description'>
            Both you and the seller can cancel the offer negotiations at any time.
          </p>
        </div>
        <div className='buttonContainer flex justifyCenter'>
          <Button onClick={onClose}>Finish</Button>
        </div>
      </div>
      <style jsx>{`
        .wrapper {
          max-width: 92vw;
          width: 43.6rem;
          min-height: 46.9rem;
          padding: 2.6rem 2.4rem 4.4rem;
          border-radius: 1rem;
          background: #fff;
        }

        h2 {
          text-align: center;
          font-size: 3.2rem;
        }

        .description {
          margin: 1.26rem 0 2.3rem;
          padding: 0 3rem;
          max-width: 50rem;
          width: 100%;
          text-align: center;
          font-size: 1.6rem;
        }

        .buttonContainer {
          width: 100%;
          margin: 2rem 0 0;

          :global(button) {
            width: 14.4rem;
            margin: 0;
          }
        }

        @media (max-width: 1024px) {
          .wrapper {
            max-width: 100%;
            width: 100%;
            height: 100%;
            padding: 5rem 1rem 0;
          }

          h2 {
            margin-top: 1.5rem;
            font-size: 1.8rem;
          }

          .description {
            margin: 0.5rem 0 1rem;
            font-size: 1.4rem;
          }

          .buttonContainer {
            position: fixed;
            left: 0;
            bottom: 2.1rem;
            z-index: 1;
            width: 100%;
            margin: 0;
            padding: 0 1.3rem;

            :global(button) {
              width: 100%;
            }
          }
        }
      `}</style>
    </Modal>
  )
}
